"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9907],{

/***/ 52479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/Button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  border-width: ",
        ";\n  border-style: solid;\n  letter-spacing: 0.3px;\n  text-transform: ",
        ";\n  width: ",
        ";\n  ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        "px;\n  display: ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  border-color: ",
        ";\n  border-color: ",
        ";\n  ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonBody = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonBody",
    componentId: "sc-989935d2-0"
})(_templateObject(), function(props) {
    return props.borderWidth || "1px";
}, function(props) {
    return props.textTransform;
}, function(props) {
    return props.fluid ? "100%" : "fit-content";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) && "width : ".concat(props === null || props === void 0 ? void 0 : props.width);
}, function(props) {
    return props.fontWeight || 500;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.display || "block";
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx, ";\n      margin-right: ").concat(props.mx, ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.variant === "outline" ? "transparent" : props.backgroundColor || "#000000";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.variant === "outline" ? props.backgroundColor : props.fontColor || "#ffffff";
}, function(props) {
    return !props.disabled && props.boxShadow;
}, function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.borderColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.whiteSpace) && "white-space: ".concat(props === null || props === void 0 ? void 0 : props.whiteSpace);
}, function(props) {
    return props.hoverEnabled && "#F8F8F8";
}, function(props) {
    return props.isDisable && "opacity: 0.5";
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js







var Button = function(props) {
    var label = props.label, args = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        children: label
    }));
};
Button.propsTypes = {
    backgroundColor: (prop_types_default()).string,
    label: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).any,
    display: (prop_types_default()).string,
    roundness: (prop_types_default()).number,
    width: (prop_types_default()).string,
    textTransform: (prop_types_default()).string,
    fontColor: (prop_types_default()).string,
    pt: (prop_types_default()).string,
    pl: (prop_types_default()).string,
    pb: (prop_types_default()).string,
    pr: (prop_types_default()).string,
    py: (prop_types_default()).string,
    px: (prop_types_default()).string,
    mt: (prop_types_default()).string,
    mb: (prop_types_default()).string,
    ml: (prop_types_default()).string,
    mr: (prop_types_default()).string,
    mx: (prop_types_default()).string,
    my: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    borderColor: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    fontSize: (prop_types_default()).number,
    variant: (prop_types_default()).string,
    whiteSpace: (prop_types_default()).string
};
/* harmony default export */ var AtomicComponents_Button = (Button);


/***/ }),

/***/ 38855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "WE": function() { return /* reexport */ CartButton/* default */.Z; },
  "rs": function() { return /* reexport */ AtomicComponents_Switch; }
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(52479);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js
var CartButton = __webpack_require__(8673);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/Switch.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: none;\n  width: ",
        ";\n  outline: none;\n  background-color: #eeeef1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n\n  color: #646464;\n\n  width: ",
        ";\n  width: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    width: 100px;\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 80px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  transform: translateY(-50%);\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 50%;\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 8px 12px;\n\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchContainer",
    componentId: "sc-3f72cec7-0"
})(_templateObject(), function(props) {
    return props.fluid ? "100%" : "fit-content";
});
var switches = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "switches",
    componentId: "sc-3f72cec7-1"
})(_templateObject1(), function(props) {
    return props.fontSize || 14;
});
var SwitchLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchLabel",
    componentId: "sc-3f72cec7-2"
})(_templateObject2(), function(props) {
    return props.width && "".concat(props.width, " !important;");
}, function(props) {
    return props.fluid && "100% !important;";
});
var SwitchToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchToggle",
    componentId: "sc-3f72cec7-3"
})(_templateObject3(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return !!props.isToggle ? "right: -5px;" : "left: -5px;";
});
var Toggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Toggle",
    componentId: "sc-3f72cec7-4"
})(_templateObject4(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness * 2);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
});

// EXTERNAL MODULE: ./src/containers/Orders/context/index.tsx
var context = __webpack_require__(60227);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/index.js





var Switch = function(props) {
    var ref = (0,react.useContext)(context/* OrderContext */.y), onChangeActiveTab = ref.onChangeActiveTab, activeTab = ref.activeTab;
    var _tabsData = props.tabsData, tabsData = _tabsData === void 0 ? [] : _tabsData, _roundness = props.roundness, roundness = _roundness === void 0 ? 2 : _roundness, _fluid = props.fluid, fluid = _fluid === void 0 ? false : _fluid, backgroundColor = props.backgroundColor, width = props.width;
    var tabRoundness = (0,util/* roundnessCalculator */.M)(roundness) || "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchContainer, {
        backgroundColor: backgroundColor,
        fluid: fluid,
        fontSize: 14,
        className: "tw-h-[48px]",
        style: {
            borderRadius: tabRoundness
        },
        children: tabsData.map(function(param) {
            var text = param.text, key = param.key;
            var isActiveTab = activeTab === key;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: width,
                onClick: function() {
                    return onChangeActiveTab(key);
                },
                isActiveTab: isActiveTab,
                className: "tw-relative tw-h-full tw-w-full tw-bg-transparent",
                style: {
                    borderRadius: tabRoundness
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isActiveTab ? "tw-absolute -tw-inset-x-[5px] -tw-inset-y-[2px] tw-z-10 tw-flex tw-items-center tw-justify-center tw-text-white" : "",
                    style: {
                        backgroundColor: isActiveTab ? backgroundColor : "transparent",
                        borderRadius: tabRoundness
                    },
                    children: text
                })
            }, key);
        })
    });
};
/* harmony default export */ var AtomicComponents_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/index.js






/***/ }),

/***/ 39907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeroBanner_HeroBanner5; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/HeroBanner5/HeroBanner5.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex !important;\n  width: 100%;\n  flex: 1;\n  position: relative;\n  box-sizing: border-box;\n  flex-direction: row-reverse;\n\n  @media screen and (min-width: 767px) {\n    ",
        "\n  }\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column-reverse;\n\n  @media screen and (min-width: 767px) {\n    flex-direction: row-reverse;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  @media screen and (min-width: 767px) {\n    height: 100%;\n    flex: 1;\n  }\n\n  @media screen and (max-width: 766px) {\n    position: relative;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  width: 100%;\n  position: relative;\n\n  & > .next-banner-image {\n    object-fit: cover;\n    height: 100%;\n    object-position: center center;\n    width: 100%;\n  }\n\n  @media screen and (max-width: 766px) {\n    & > .next-banner-image {\n      object-position: center 25%;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 767px) {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    position: relative;\n    height: 50%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  color: ",
        ";\n  width: 100%;\n  box-sizing: border-box;\n\n  @media screen and (min-width: 767px) {\n    height: fit-content;\n    max-width: 400px;\n    padding: 1rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 2rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  overflow: hidden;\n  overflow: hidden;\n  position: relative;\n\n  & > .next-store-image {\n    width: 100%;\n    height: 100%;\n    object-position: center center;\n  }\n\n  @media screen and (min-width: 767px) {\n    height: 77px;\n    width: 77px;\n    margin: 0 auto 20px;\n  }\n\n  @media screen and (max-width: 766px) {\n    height: 57px;\n    width: 57px;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  width: 100%;\n  margin: 0;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media screen and (min-width: 767px) {\n    font-size: 39px;\n    margin-bottom: 30px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 27px;\n    margin-bottom: 15px;\n    margin-top: 5px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  width: 100%;\n  text-align: center;\n  max-width: 300px;\n  -webkit-touch-callout: text;\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n    max-width: 350px;\n    margin: 0 auto 30px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    margin: 0 auto 15px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  cursor: pointer;\n  line-height: 1.4;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 100%;\n\n  & > button {\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var getBannerHeight = function(props, deviceType) {
    var headerHeight = props.heightCalculation || (deviceType === "mobile" ? 80 : 90);
    if (props.bannerFixedRatio === 0) {
        // fixed height
        if (deviceType === "mobile") {
            return "height: calc(100vh - ".concat(headerHeight, "px)");
        } else {
            return "height: calc(100vh - ".concat(headerHeight, "px)");
        }
    } else {
        // fixed aspect ratio
        if (deviceType === "mobile") {
            return "height: 0; padding-top: ".concat(16 / 9 * 100, "%;");
        } else {
            return "height: 0; padding-top: ".concat(9 / 16 * 100, "%;");
        }
    }
};
var HeroBannerComponent = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "HeroBannerComponent",
    componentId: "sc-9395e9bf-0"
})(_templateObject(), function(props) {
    return getBannerHeight(props, "desktop");
}, function(props) {
    return getBannerHeight(props, "mobile");
});
var HeroBannerMainContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerMainContent",
    componentId: "sc-9395e9bf-1"
})(_templateObject1());
var HeroBannerImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerImageContainer",
    componentId: "sc-9395e9bf-2"
})(_templateObject2(), function(props) {
    return props.height ? "50%" : "100%";
});
var HeroBannerImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeroBannerImage",
    componentId: "sc-9395e9bf-3"
})(_templateObject3());
var HeroBannerInteractivePosition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerInteractivePosition",
    componentId: "sc-9395e9bf-4"
})(_templateObject4());
var HeroBannerInteractiveBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerInteractiveBody",
    componentId: "sc-9395e9bf-5"
})(_templateObject5(), function(props) {
    return props.fontColor;
});
var HeroBannerStoreImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerStoreImage",
    componentId: "sc-9395e9bf-6"
})(_templateObject6(), function(props) {
    return props.roundness;
});
var HeroBannerHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "HeroBannerHeading",
    componentId: "sc-9395e9bf-7"
})(_templateObject7());
var HeroBannerDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "HeroBannerDescription",
    componentId: "sc-9395e9bf-8"
})(_templateObject8());
var ViewMoreSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ViewMoreSpan",
    componentId: "sc-9395e9bf-9"
})(_templateObject9());
var HeroBannerCTAButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerCTAButton",
    componentId: "sc-9395e9bf-10"
})(_templateObject10());

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/utils/renderStoreName.js
var renderStoreName = __webpack_require__(16802);
// EXTERNAL MODULE: ./src/utils/bannerImageClick.js
var bannerImageClick = __webpack_require__(80841);
// EXTERNAL MODULE: ./src/utils/heroBannerCTASystem.js
var heroBannerCTASystem = __webpack_require__(23679);
// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(42783);
// EXTERNAL MODULE: ./src/hooks/useShopClickFunc.js
var useShopClickFunc = __webpack_require__(66834);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/hooks/useBannerImages.js + 1 modules
var useBannerImages = __webpack_require__(44206);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/common/BannerImageSliderNextPrevButtons.js
var BannerImageSliderNextPrevButtons = __webpack_require__(22398);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/utils.js
var utils = __webpack_require__(65710);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/HeroBanner5/index.js






















var HeroBanner5 = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useShopClickFunc/* useShopClickFunc */.Y)(), 1), shopBtnClick = ref[0];
    var router = (0,next_router.useRouter)();
    var sliderRef = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var heroBannerHeight = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer.heightCalculation;
    }).heroBannerHeight;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }), store_info = ref1.store_info, theme = ref1.theme;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBannerImages/* default */.Z)(), 1), bannerImages = ref2[0];
    var ref3 = (0,react.useState)({
        isHeightFetched: false,
        heightFetched: 0
    }), state = ref3[0], setState = ref3[1];
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    (0,react.useEffect)(function() {
        if (!state.heightFetched) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    heightFetched: heroBannerHeight,
                    isHeightFetched: true
                });
            });
        }
    }, [
        heroBannerHeight
    ]);
    return theme ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "heroBannerWrapper ".concat(!(bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.length) ? "placeholder" : ""),
        children: [
            (bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImageSliderNextPrevButtons/* default */.Z, {
                sliderRef: sliderRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: function(slider) {
                    return sliderRef.current = slider;
                }
            }, utils/* sliderSettings */.K), {
                children: bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.map(function(img, idx) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerComponent, {
                        bannerFixedRatio: theme === null || theme === void 0 ? void 0 : theme.banner_fixed_ratio,
                        heightCalculation: state.heightFetched,
                        className: (img === null || img === void 0 ? void 0 : img.image_href) !== "" ? "pointer" : "",
                        onClick: function() {
                            return (0,bannerImageClick/* bannerImageClick */.X)(theme, img);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerMainContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerImageContainer, {
                                    height: idx === 0 && (((ref = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref === void 0 ? void 0 : ref.logo) || ((ref1 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref1 === void 0 ? void 0 : ref1.storeName)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerImage, {
                                        children: img.image_url && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "fill",
                                            className: "next-banner-image",
                                            objectFit: "cover",
                                            objectPosition: deviceWidth/* deviceWidth */.o > 766 ? "center center" : "center 25%",
                                            alt: "Main Banner Image ".concat(idx + 1),
                                            src: img.image_url,
                                            priority: idx == 0
                                        })
                                    })
                                }),
                                idx === 0 && (((ref2 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref2 === void 0 ? void 0 : ref2.logo) || ((ref3 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref3 === void 0 ? void 0 : ref3.storeName)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerInteractivePosition, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerInteractiveBody, {
                                        fontColor: theme === null || theme === void 0 ? void 0 : (ref4 = theme.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color,
                                        children: [
                                            ((ref5 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref5 === void 0 ? void 0 : ref5.logo) && (store_info === null || store_info === void 0 ? void 0 : store_info.logo_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerStoreImage, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: store_info === null || store_info === void 0 ? void 0 : store_info.logo_image,
                                                    className: "next-store-image",
                                                    alt: "store logo",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectPosition: "center center"
                                                })
                                            }),
                                            ((ref6 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref6 === void 0 ? void 0 : ref6.storeName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerHeading, {
                                                children: store_info === null || store_info === void 0 ? void 0 : store_info.name
                                            }),
                                            store_info && (store_info === null || store_info === void 0 ? void 0 : store_info.description) && (store_info === null || store_info === void 0 ? void 0 : store_info.description.length) > 164 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerDescription, {
                                                children: [
                                                    store_info === null || store_info === void 0 ? void 0 : store_info.description.substr(0, 164),
                                                    "...",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreSpan, {
                                                        onClick: function() {
                                                            router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                        },
                                                        children: "View More"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerDescription, {
                                                children: store_info === null || store_info === void 0 ? void 0 : store_info.description
                                            }),
                                            (0,heroBannerCTASystem/* heroBannerCTASystem */.E)(theme === null || theme === void 0 ? void 0 : theme.theme_class) !== "" && (theme === null || theme === void 0 ? void 0 : (ref7 = theme.cta_config) === null || ref7 === void 0 ? void 0 : ref7.banner_cta) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerCTAButton, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                                    backgroundColor: theme === null || theme === void 0 ? void 0 : (ref8 = theme.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color,
                                                    label: theme === null || theme === void 0 ? void 0 : (ref9 = theme.cta_config) === null || ref9 === void 0 ? void 0 : ref9.banner_cta,
                                                    roundness: theme === null || theme === void 0 ? void 0 : theme.roundness,
                                                    fontColor: "#ffffff",
                                                    px: "10px",
                                                    py: "10px",
                                                    onClick: shopBtnClick
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, idx);
                })
            }))
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var HeroBanner_HeroBanner5 = (HeroBanner5);


/***/ }),

/***/ 22398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var BannerImageSliderNextPrevButtons = function(param) {
    var sliderRef = param.sliderRef;
    /* slider prev button */ var handlePrevClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPrev();
        }
    };
    /* slider next button */ var handleNextClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickNext();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "Left Button",
                src: "/assets/icons/arrowLeftIconCircleDark.png",
                className: "arrow-btns absolute left-1 img h2 mr2 pointer",
                onClick: handlePrevClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "Right Button",
                src: "/assets/icons/arrowRightIconCircleDark.png",
                className: "arrow-btns absolute right-1 img h2 mr2 pointer",
                onClick: handleNextClick
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BannerImageSliderNextPrevButtons);


/***/ }),

/***/ 44206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useBannerImages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/redux/useSSRSelector.tsx
var useSSRSelector = __webpack_require__(2808);
;// CONCATENATED MODULE: ./src/hooks/useDeviceInfo.js


function useDeviceInfo() {
    var userAgent = (0,react.useContext)(useSSRSelector/* SSRSelectorContext */.v).userAgent;
    var isMobile = mobileCheck(userAgent);
    var isDesktop = !isMobile;
    return {
        isMobile: isMobile,
        isDesktop: isDesktop,
        isInvalidDevice: isMobile === null
    };
}
function mobileCheck(userAgent) {
    if (!userAgent) return null;
    var check = false;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) check = true;
    return check;
}

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(71778);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/hooks/useBannerImages.js





var useBannerImages = function() {
    var isBannerListImageSame = function isBannerListImageSame(imgList) {
        var isBannerListSame = true;
        if (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : bannerImagesListClient.length) {
            for(var i = 0; i < (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : bannerImagesListClient.length); i++){
                var ref, ref1;
                if ((imgList === null || imgList === void 0 ? void 0 : (ref = imgList[i]) === null || ref === void 0 ? void 0 : ref.image_url) !== (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : (ref1 = bannerImagesListClient[i]) === null || ref1 === void 0 ? void 0 : ref1.image_url)) {
                    isBannerListSame = false;
                    break;
                }
            }
            return isBannerListSame;
        }
    };
    var getFilteredBannerImages = function getFilteredBannerImages(isDesktop) {
        var ref, ref1, ref2, ref3;
        var sortedImages = ((ref2 = theme === null || theme === void 0 ? void 0 : (ref = theme.components) === null || ref === void 0 ? void 0 : (ref1 = ref.Body) === null || ref1 === void 0 ? void 0 : ref1.find(function(comp) {
            return (comp === null || comp === void 0 ? void 0 : comp.sub_type) === "HeroBanner";
        })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.sort(function(a, b) {
            return a.order - b.order;
        })) || [];
        if (isDesktop) {
            bannerImagesList = sortedImages.filter(function(el) {
                return el.is_desktop === true;
            });
        } else {
            bannerImagesList = sortedImages.filter(function(el) {
                return el.is_desktop === false;
            });
        }
        return bannerImagesList;
    };
    var ref = (0,react.useState)(false), isDocumentLoaded = ref[0], setDocumentLoaded = ref[1];
    var isDesktop = useDeviceInfo().isDesktop;
    var theme = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var bannerImagesList = [];
    // This will be false on Server & on Initial render itself
    if (!isComponentMounted) {
        bannerImagesList = getFilteredBannerImages(isDesktop);
    }
    var ref1 = (0,react.useState)(bannerImagesList || []), bannerImagesListClient = ref1[0], setBannerImagesListClient = ref1[1];
    (0,react.useEffect)(function() {
        window.addEventListener("load", function() {
            setTimeout(function() {
                return setDocumentLoaded(true);
            }, 2000);
        });
    }, []);
    (0,react.useEffect)(function() {
        var isDesktopBasedOnDeviceWidth = deviceWidth/* deviceWidth */.o > 767;
        var bannerImagesList = getFilteredBannerImages(isDesktopBasedOnDeviceWidth);
        if (!isBannerListImageSame(bannerImagesList)) {
            setBannerImagesListClient(bannerImagesList);
        }
    }, []);
    var bannerImages = !isDocumentLoaded ? bannerImagesListClient.slice(0, 1) : bannerImagesListClient;
    return [
        bannerImages
    ];
};
/* harmony default export */ var hooks_useBannerImages = (useBannerImages);


/***/ }),

/***/ 65710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ sliderSettings; }
/* harmony export */ });
/**
 * Slider base values
 */ var sliderSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 3000,
    dotsClass: "herobanner_slider--icons"
};


/***/ }),

/***/ 60227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ OrderContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var OrderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 66834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useShopClickFunc; }
/* harmony export */ });
/* harmony import */ var _utils_eventLogger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4134);
/* harmony import */ var _constants_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17584);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44541);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/*
  common functions to be used inside
  herobanners used in store
  allows reusability
*/ 




/*
  This function is used on Shop Now button in herobanners
  if collection widget is used, scroll to that position
  if not redirect to shop
*/ function useShopClickFunc() {
    var store_info = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            store_info: state.storeReducer.store
        };
    }).store_info;
    var shopBtnClick = function() {
        (0,_utils_eventLogger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_constants_common__WEBPACK_IMPORTED_MODULE_1__/* .EVENT_NAMES.HERO_BANNER_SHOP_BUTTON */ .Kg.HERO_BANNER_SHOP_BUTTON, null, true);
        if (document.querySelector("#CollectionCategoryProductWidget")) {
            document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_3___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_2__.PATH.SHOP, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
        }
    };
    return [
        shopBtnClick
    ];
}


/***/ }),

/***/ 80841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ bannerImageClick; }
/* harmony export */ });
/**
 * opening new window to show banner image if image_href exists
 * @param {*} theme
 * @param {*} img
 */ var bannerImageClick = function(theme, img) {
    if ((theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) && (img === null || img === void 0 ? void 0 : img.image_href)) {
        window.open("".concat(img.image_href), "_blank");
    }
};


/***/ }),

/***/ 4134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67936);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);



var eventLogger = function(eventName) {
    var additionalData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, showInConsole = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var userData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.data;
    var eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        phone: (userData === null || userData === void 0 ? void 0 : userData.phone) || "",
        email: (userData === null || userData === void 0 ? void 0 : userData.email) || ""
    }, additionalData);
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .pushEventsLog */ .U)({
        event_name: eventName,
        data: eventData
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (eventLogger);


/***/ }),

/***/ 23679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ heroBannerCTASystem; }
/* harmony export */ });
var heroBannerCTASystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return "Shop Now";
        case 2:
            return "Explore";
        case 3:
            return "";
        case 4:
            return "";
        default:
            return "Shop Now";
    }
};


/***/ }),

/***/ 16802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ renderStoreName; }
/* harmony export */ });
/**
 * * check for existence of logo and store name in config
 * @param {*} deviceWidth number
 * @param {*} config Object
 * @return {*} obj
 */ var renderStoreName = function() {
    var deviceWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var returnObj = {
        logo: true,
        storeName: true
    };
    // only for custom website config exist.
    // So for non premium website return true for logo and name
    if (deviceWidth > 720 && config && Object.keys(config).length) {
        return {
            logo: config === null || config === void 0 ? void 0 : config.show_logo,
            storeName: config === null || config === void 0 ? void 0 : config.show_store_name
        };
    }
    return returnObj;
};


/***/ }),

/***/ 71778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/*
  Returns isComponentMounted
  isComponentMounted -> true / Component is Successfully mounted
*/ function useIsComponentMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isComponentMounted = ref[0], setIsComponentMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsComponentMounted(true);
    }, []);
    return isComponentMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsComponentMounted);


/***/ })

}]);